import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RequestService } from '../shared/request.service';
import { DocumentDelivery } from '../shared/model/document-delivery.model';

@Component({
  selector: 'app-check-documents',
  templateUrl: './check-documents.component.html',
  styleUrls: ['./check-documents.component.scss']
})
export class CheckDocumentsComponent implements OnInit {

  documents: DocumentDelivery[];
  isPifle = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<CheckDocumentsComponent>
              , private requestService: RequestService) {
                this.isPifle = this.data.request.solicitud.tipo === 'PRUEBA LENGUA EXTRANJERA';
              }

  ngOnInit() {
    this.requestService.getDocumentsDelivery(this.data.request.solicitud.solicitud,
      this.data.request.solicitud.tipo).subscribe(
        (result) => {
         if (result.data) {
           this.documents = result.data as DocumentDelivery[];
           this.documents = this.documents.map(
             (item) => {
               item.initalState =  item.estadoDocumento;
               return item;
             }
           );
         }
        }
      );
  }

  close() {
    this.dialogRef.close(null);
  }

 sendSelect() {
  let documentsCkecked = '';
  this.documents.forEach( (item) => {
    if (!item.initalState && item.estadoDocumento) {
      documentsCkecked = documentsCkecked + '|' + item.requisito.requisito;
    }
  });
  const data = { index: this.data.index , documents: documentsCkecked, isPifle: this.isPifle };
  this.dialogRef.close(data);
 }

}
